import React, { useEffect, useRef, useState } from 'react'
import './search-summary.scss'
import {
	getDensityUnit,
	getWeightUnit,
	DIMENSION_UNIT,
	WEIGHT_UNIT,
	SHIPPING_TYPE,
	getVolumeUnit,
	calculateDensity,
	getDecimalFormattedNumber,
	getFormattedNumber,
	getOneDecimalFormattedNumber,
	getRoundedValue,
} from '../../constants'
import calculateKgWeight from '../../utils/calculateKgWeight'
import { Message } from 'primereact/message'
import { calculateWeightToKg, round } from '../../utils/common'
import { useTranslation } from 'react-i18next'
import MESSAGES from '../../constants/Messages'
import { Divider } from '../../common/Divider'
import { AlertMessage } from '../SearchPanel/AlertMessage'

const SearchSummary = ({
	totalPieces,
	totalVolumeInMtrs,
	totalWeightInKg,
	weightUnit,
	dimensionUnit,
	chargeableWeight,
	looseDetails,
	shippingType,
	totalWeight,
	looseItemsGrossWeight,
	calculatedTotalWeight,
	actualGrossWeight,
	actualTotalIneItemWeight,
	actualVolume,
	setGrossWeightInSelectedUnit,
	setGrossWeightInConvertedUnit,
	setDensityInSelectedUnit,
	setdensityInConvertedUnit,
	chargeableWeightInSelectedUnit,
	cageList,
	shippingItem,
	AviEnabled,
	cages,
}) => {
	/*for multilingual*/
	const { t, i18n } = useTranslation(['labels'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	let weightMismatch = false

	const getLooseChargeableWeight = () => {
		let count = 0
		looseDetails.forEach(function (element) {
			if (!element.stackable) {
				count++
			}
		})
		if (count) {
			return false
		} else {
			return true
		}
	}


	const getPetsSum = () => {
		let petList = cages.map((item) => {
			return item.pets.length
		})
		let sum = 0;
		for (const item of petList) {
			sum += item;
		}
		if (sum > 1) {
			return sum + ' Pets';
		}
		else {
			return sum + ' Pet';
		}
	}

	const getCageString = (length) => {
		let cageString = length > 1 ? 'Containers' : 'Container'
		return cageString;
	}

	return (
		<>
			<div className='search-summary-row'>
				<h3>{t("BOOKING.WEIGHT_DETAILS")}</h3>
				<div className='summary-body'>
					<div className={`summ-details-row`} >
						<label>{AviEnabled ? t('COMMON.QTY') : t('COMMON.PCS')} </label>
						<div className='value-field'>{cages && cages[0]?.weight ? `${getPetsSum()} in ${cages.length} ${getCageString(cages.length)}` : getFormattedNumber(totalPieces)}</div>
					</div>
					<Divider />
					<div className={`summ-details-row`}>
						<label>{t('COMMON.GROSS_WT')}</label>
						{shippingType && shippingType === SHIPPING_TYPE.LOOSE ? (
							<div
								className={`value-field
										${actualGrossWeight &&
										actualTotalIneItemWeight &&
										actualGrossWeight * 1 > actualTotalIneItemWeight * 1
										? 'highlight-weight'
										: ''
									}`}
							>
								<span style={{ display: 'inline' }}>
									{actualGrossWeight && actualTotalIneItemWeight &&
										actualGrossWeight * 1 > actualTotalIneItemWeight * 1
										?
										(setGrossWeightInSelectedUnit(
											getOneDecimalFormattedNumber(actualGrossWeight)
										),
											getOneDecimalFormattedNumber(actualTotalIneItemWeight) +
											' of ' +
											getOneDecimalFormattedNumber(actualGrossWeight))
										: actualGrossWeight
											? (setGrossWeightInSelectedUnit(
												actualGrossWeight
											),
												actualGrossWeight)
											: (setGrossWeightInSelectedUnit(0), 0)
									}
								</span>
								<span style={{ display: 'inline' }}>
									{getWeightUnit(weightUnit)}
								</span>
								<span style={{ display: 'inline' }}>
									{totalWeight &&
										calculatedTotalWeight &&
										totalWeight * 1 > calculatedTotalWeight * 1
										? setGrossWeightInConvertedUnit(
											round(
												calculateWeightToKg(calculatedTotalWeight, weightUnit), 2
											)
										)
										: totalWeightInKg
											? setGrossWeightInConvertedUnit(
												round(totalWeightInKg, 2)
											)
											: setGrossWeightInConvertedUnit(0)}
								</span>
							</div>
						) : (
							<></>
						)}

						{shippingType && shippingType === SHIPPING_TYPE.ULD ? (
							<div className='value-field'>
								<span style={{ display: 'inline' }}>
									{actualGrossWeight
										? (setGrossWeightInSelectedUnit(
											getOneDecimalFormattedNumber(actualGrossWeight)
										),
											getOneDecimalFormattedNumber(actualGrossWeight))
										: (setGrossWeightInSelectedUnit(0), 0)}
								</span>
								<span style={{ display: 'inline' }}>
									{getWeightUnit(weightUnit)}
								</span>
								{totalWeightInKg
									? setGrossWeightInConvertedUnit(
										round(totalWeightInKg, 2)
									)
									: setGrossWeightInSelectedUnit(0)
								}
							</div>
						) : (
							<></>
						)}
					</div>
					<Divider />
					<div className={`summ-details-row`}>
						<label>{t('COMMON.VOL')} </label>
						{dimensionUnit === DIMENSION_UNIT.CENTIMETERS ? (
							<div className='value-field'>
								<span style={{ display: 'inline' }}>
									{getDecimalFormattedNumber(totalVolumeInMtrs)}
								</span>
								<span style={{ display: 'inline' }}>
									{getVolumeUnit(DIMENSION_UNIT.METERS)}
								</span>
							</div>
						) : (
							<div className='value-field'>
								<span style={{ display: 'inline' }}>
									{getDecimalFormattedNumber(actualVolume)}
								</span>
								<span style={{ display: 'inline' }}>
									{getVolumeUnit(dimensionUnit)}
								</span>
							</div>
						)}
					</div>
					<Divider />
					<div className={`summ-details-row`}>
						<label>{t('COMMON.DENSITY')} </label>
						{dimensionUnit === DIMENSION_UNIT.CENTIMETERS ? (
							<div className={`value-field ${isRTL ? 'rtl-numeric' : ''}`}>
								<span style={{ display: 'inline' }}>
									{actualGrossWeight && totalVolumeInMtrs
										? (setDensityInSelectedUnit(
											calculateDensity(totalVolumeInMtrs, actualGrossWeight)
										),
											calculateDensity(totalVolumeInMtrs, actualGrossWeight))
										: '0'}
								</span>
								<span style={{ display: 'inline-block' }}>
									{getDensityUnit(weightUnit, DIMENSION_UNIT.METERS)}
								</span>
								{totalWeightInKg && totalVolumeInMtrs
									? setdensityInConvertedUnit(
										calculateDensity(totalVolumeInMtrs, totalWeightInKg)
									)
									: setdensityInConvertedUnit(0)}
							</div>
						) : (
							<div className={`value-field ${isRTL ? 'rtl-numeric' : ''}`}>
								<span style={{ display: 'inline' }}>
									{actualGrossWeight && actualVolume
										? (setDensityInSelectedUnit(
											calculateDensity(actualVolume, actualGrossWeight)
										),
											calculateDensity(actualVolume, actualGrossWeight))
										: (setDensityInSelectedUnit(0.0), 0.0)}
								</span>
								<span style={{ display: 'inline-block' }}>
									{getDensityUnit(weightUnit, dimensionUnit)}
								</span>

								{totalWeightInKg && totalVolumeInMtrs
									? setdensityInConvertedUnit(
										calculateDensity(totalVolumeInMtrs, totalWeightInKg)
									)
									: setdensityInConvertedUnit(0)}
							</div>
						)}
					</div>
					<Divider />
					{(cageList && cageList.length > 0 && (shippingItem?.code === 'DOG' || shippingItem?.code === 'CAT')) || (shippingType &&
						shippingType === SHIPPING_TYPE.LOOSE &&
						getLooseChargeableWeight()) ? (
						<div className={`summ-details-row`}>

							<label>{t('COMMON.CH_WT')} </label>
							<div className={`value-field ${isRTL ? 'rtl-numeric' : ''}`}>
								<span style={{ display: 'inline' }}>
									{chargeableWeightInSelectedUnit && actualGrossWeight
										? getRoundedValue(chargeableWeightInSelectedUnit)
										: 0.0}
								</span>
								<span style={{ display: 'inline-block' }}>
									{getWeightUnit(weightUnit)}
								</span>
							</div>
						</div>
					) : (
						<></>
					)}
					{shippingType && shippingType === SHIPPING_TYPE.ULD ? (
						<div className={`summ-details-row`}>
							<label>Chargeable weight </label>
							<div className='value-field'>
								<span style={{ display: 'inline' }}>
									{chargeableWeightInSelectedUnit && actualGrossWeight
										? getRoundedValue(chargeableWeightInSelectedUnit)
										: 0.0}
								</span>
								<span style={{ display: 'inline-block' }}>
									{getWeightUnit(weightUnit)}
								</span>
							</div>
						</div>
					) : (
						<></>
					)}

					{(!AviEnabled && shippingType &&
						shippingType === SHIPPING_TYPE.LOOSE &&
						!getLooseChargeableWeight()) && (shippingItem?.code !== 'DOG' && shippingItem?.code !== 'CAT') ? (
						<AlertMessage
							message={t(MESSAGES.CHARGEABLE_WT_DIFFER_MSG, { ns: 'errors' })}
							className={'my-3'}
						/>
					) : (
						<></>
					)}
					{shippingType === SHIPPING_TYPE.LOOSE &&
						totalWeight && (shippingItem?.code !== 'DOG' && shippingItem?.code !== 'CAT') &&
						looseDetails.find((detail) => detail.weight) ? (
						<AlertMessage
							message={t(MESSAGES.PIECE_LEVEL_WT_DISREGARD, { ns: 'errors' })}
							className={'my-3'}
						/>
					) : (
						<></>
					)}
				</div>
			</div>
		</>
	)
}
export default SearchSummary
